import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(0, 3, 3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '& .msg': {
      '&-text': {
        color: theme.palette.text.secondary,
        margin: theme.spacing(3, 0),
        textAlign: 'center',
      },
      '&-btn': {
        color: theme.palette.primary.main,
        '&.completed': {
          color: theme.palette.custom.feedback.positive,
        },
      },
    },

    '& .skeleton-questions': {
      '&-container': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(3),
        width: '100%',
      },
      '&-illustration': {
        width: theme.spacing(10),
        height: theme.spacing(10),
      },
      '&-title': {
        width: '100%',
        maxWidth: theme.spacing(40),
        margin: theme.spacing(3, 0),
      },
      '&-button': {
        width: '90%',
        maxWidth: theme.spacing(30),
        height: theme.spacing(5),
        borderRadius: theme.shape.borderRadius,
      },
    },
  },
}));

export default styles;
